import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { PartyPopper, ArrowRight, MapIcon } from "lucide-react";
import { Link } from "react-router-dom";
import MomentBanner from "@/components/MomentBanner";

export default function CompleteScreen({ payload, mode = "subtopic", onNext, onEndSession }) {
  const moment = payload?.mitraa_moment;
  const momentQueue = payload?.mitraa_moment_queue || [];
  
  return (
    <div className="fade-up max-w-2xl mx-auto" data-testid={`complete-screen-${mode}`}>
      {/* Primary Moment Banner */}
      <MomentBanner moment={moment} className="mb-4" />
      
      {/* Queued Moments (Moment 25 after 19/20) */}
      {momentQueue.map((queuedMoment, idx) => (
        <MomentBanner 
          key={`queued-${queuedMoment.moment_id || idx}`} 
          moment={queuedMoment} 
          className="mb-4" 
        />
      ))}
      
      <Card className="rounded-3xl p-10 mit-shadow border-emerald-200 bg-emerald-50 text-center">
        <div className="w-24 h-24 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-5">
          <PartyPopper className="w-12 h-12 text-emerald-600" />
        </div>
        <h2 className="font-display text-3xl font-bold text-emerald-900 mb-3" data-testid="complete-headline">
          {mode === "session" ? "Session complete!" : "Sub-topic done!"}
        </h2>
        <p className="text-slate-700 text-lg mb-6" data-testid="complete-summary">
          {payload?.summary}
        </p>

        {payload?.stats && (
          <div className="flex justify-center gap-4 mb-6 flex-wrap">
            <div className="bg-white rounded-2xl px-5 py-3 border border-emerald-100">
              <div className="text-xs uppercase font-semibold text-slate-500">Questions</div>
              <div className="text-2xl font-bold font-display text-emerald-700" data-testid="complete-stat-attempts">
                {payload.stats.attempts}
              </div>
            </div>
            <div className="bg-white rounded-2xl px-5 py-3 border border-emerald-100">
              <div className="text-xs uppercase font-semibold text-slate-500">Got right</div>
              <div className="text-2xl font-bold font-display text-emerald-700" data-testid="complete-stat-correct">
                {payload.stats.correct}
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {mode === "subtopic" && onNext && (
            <Button onClick={onNext} className="rounded-full bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-6 tap-44" data-testid="complete-next-btn">
              Next sub-topic <ArrowRight className="w-5 h-5 ml-1" />
            </Button>
          )}
          {mode === "subtopic" && onEndSession && (
            <Button onClick={onEndSession} variant="outline" className="rounded-full border-2 border-slate-200 px-8 py-6 tap-44" data-testid="complete-end-session-btn">
              End session
            </Button>
          )}
          {mode === "session" && (
            <Link to="/journey">
              <Button className="rounded-full bg-sky-500 hover:bg-sky-600 text-white px-8 py-6 tap-44" data-testid="complete-journey-btn">
                <MapIcon className="w-5 h-5 mr-1" /> See journey map
              </Button>
            </Link>
          )}
          {mode === "session" && (
            <Link to="/home">
              <Button variant="outline" className="rounded-full border-2 border-slate-200 px-8 py-6 tap-44" data-testid="complete-home-btn">
                Back home
              </Button>
            </Link>
          )}
        </div>
      </Card>
    </div>
  );
}
